/* ============================================================
   PDP GEL V2 — Variant B behaviors for gel_pdp_structure_v1
   Tab switching and FAQ accordion. Event-delegated so it works
   regardless of whether sections render at static-load or get
   revealed later by the PostHog onFeatureFlags callback.
   ============================================================ */

(function() {
  'use strict';


  // ---- Details tabs (used by pdp-gel-v2-details-tabs) ----

  document.addEventListener('click', function(e) {
    var tab = e.target.closest('[data-pdpv2-details-tab]');
    if (!tab) return;

    var tabsRoot = tab.closest('[data-pdpv2-details-tabs]');
    if (!tabsRoot) return;

    var target = tab.getAttribute('data-pdpv2-details-tab');

    tabsRoot.querySelectorAll('[data-pdpv2-details-tab]').forEach(function(t) {
      t.classList.toggle('is-active', t === tab);
      t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
    });

    tabsRoot.querySelectorAll('[data-pdpv2-details-panel]').forEach(function(panel) {
      var match = panel.getAttribute('data-pdpv2-details-panel') === target;
      panel.classList.toggle('is-active', match);
      panel.setAttribute('aria-hidden', match ? 'false' : 'true');
    });
  });

  // ---- Tabs (used by §2 pdp-gel-v2-tabs) ----

  document.addEventListener('click', function(e) {
    var tab = e.target.closest('[data-pdpv2-tab]');
    if (!tab) return;

    var tabsRoot = tab.closest('[data-pdpv2-tabs-root]');
    if (!tabsRoot) return;

    var target = tab.getAttribute('data-pdpv2-tab');

    tabsRoot.querySelectorAll('[data-pdpv2-tab]').forEach(function(t) {
      t.classList.toggle('is-active', t === tab);
      t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
    });

    tabsRoot.querySelectorAll('[data-pdpv2-tab-panel]').forEach(function(panel) {
      var match = panel.getAttribute('data-pdpv2-tab-panel') === target;
      panel.classList.toggle('is-active', match);
      panel.setAttribute('aria-hidden', match ? 'false' : 'true');
    });
  });

  // ---- FAQ accordion (used by §7 pdp-gel-v2-faq) ----

  document.addEventListener('click', function(e) {
    var row = e.target.closest('[data-pdpv2-faq-row]');
    if (!row) return;

    var isOpen = row.classList.toggle('is-open');
    var body = row.nextElementSibling;
    if (body && body.matches('[data-pdpv2-faq-body]')) {
      body.classList.toggle('is-open', isOpen);
      body.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    }
    row.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  // ---- UGC carousel nav (used by §6 pdp-gel-v2-ugc when blocks > 4) ----

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-pdpv2-ugc-prev], [data-pdpv2-ugc-next]');
    if (!btn) return;

    var carousel = btn.closest('.ugc-carousel');
    if (!carousel) return;

    var scroller = carousel.querySelector('[data-pdpv2-ugc-scroll]');
    if (!scroller) return;

    var direction = btn.hasAttribute('data-pdpv2-ugc-next') ? 1 : -1;
    scroller.scrollBy({ left: direction * scroller.clientWidth, behavior: 'smooth' });
  });

  // ---- Keyboard accessibility ----

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;

    var interactive = e.target.closest('[data-pdpv2-tab], [data-pdpv2-faq-row]');
    if (!interactive) return;

    e.preventDefault();
    interactive.click();
  });
})();
